angular.module('cfn').factory('timeFormatter', function() {
  /*
     *  public
     */
  return {
    hour: {
      strToInt: function(hourStr) {
        return strToInt(hourStr, 23);
      },
      intToStr: function(hourInt) {
        return intToStr(hourInt);
      }
    },
    minute: {
      strToInt: function(hourStr) {
        return strToInt(hourStr, 59);
      },
      intToStr: function(hourInt) {
        return intToStr(hourInt);
      }
    },
    directiveHelpers: {
      checkIfInputfieldNeedsUpdate: function(newHourInt, fromInputStr) {
        var isNotInputEmpty = fromInputStr !== '',
          isIntSameAsInput = newHourInt != fromInputStr,
          isInputTooManyCharacters = fromInputStr.length > 2,
          doUpdateInputValue = isIntSameAsInput && isNotInputEmpty;
        if (isInputTooManyCharacters && isNotInputEmpty) {
          doUpdateInputValue = true;
        }
        return doUpdateInputValue;
      }
    }
  };

  /*
     *  private
     */
  function strToInt(str, limitTo) {
    var int;

    // 1. check string validity
    if (str === '') {
      return null;
    }

    if (str.length > 2) {
      str = str.substr(0, 2);
    }

    // 2. check integer validity
    int = parseInt(str);

    if (int > limitTo) {
      int = limitTo;
    } else if (_(int).isNaN()) {
      int = null;
    }

    return int;
  }

  function intToStr(int) {
    var isNotSet = _(int).isNull() || _(int).isUndefined(),
      str = isNotSet ? '' : int.toString();

    if (int < 10 && !isNotSet) {
      str = '0' + int;
    }

    return str;
  }
});
